import { NOTIFICATION_TYPES } from "./collaborationSettings.types";

/**
 * Convert values from object to array of [type, value]
 * @returns Array of values from the form [type, value]
 */
export const convertValuesObjectToArray = (values: object) => {
  const resValues = [];
  for (const [type, value] of Object.entries(values)) {
    resValues.push({
      type,
      value
    });
  }

  return resValues;
};

/**
 * Calculate the default settings for the teams, while taking consideration the org level overrides
 * allSettings - All the settings for the current org (org/repo/team/setting definition)
 * @returns Default settings
 */
export const calcDefaultSettings = ({ allSettings }: { allSettings: any }) => {
  // Get the organization level default settings
  const orgDefaultSettings = allSettings.filter(
    setting =>
      NOTIFICATION_TYPES.includes(setting.name) &&
      setting.definitionLevel === 'organization'
  );
  // Get the team level default settings
  const teamDefaultSettings = allSettings.filter(
    setting => NOTIFICATION_TYPES.includes(setting.name) && setting.definitionLevel === 'team'
  );

  return teamDefaultSettings.map(setting => {
    const orgSetting = orgDefaultSettings.filter(
      orgSetting => orgSetting.name === setting.name
    );
    if (!orgSetting.length) {
      return setting;
    }

    // Get the org level overrides if exists
    const orgOverrideSetting = allSettings.filter(
      setting => setting.definitionId === orgSetting[0].id && setting.teamId === null
    );

    if (!orgOverrideSetting.length) {
      return setting;
    }

    return { ...setting, values: orgOverrideSetting[0].value };
  });
};

/**
 *  Calculate the default notifications data
 *  defaultSettings - Default settings for the organization
 * @returns Default notifications
 */
export const calcDefaultNotifications = ({ defaultSettings }: { defaultSettings: any }) => {
  return defaultSettings.reduce(
    (acc, { id, label, name, values, defaultValue, customOptions }) => {
      const { enabled: defaultEnabled, ...restOfDefault } = defaultValue;
      let restOfValues = restOfDefault;
      let enabled = defaultEnabled;
      if (values) {
        ({ enabled, ...restOfValues } = values);
      }
      acc[id] = {
        id,
        name: label,
        enabled,
        limits: customOptions,
        notificationKey: name,
        values: convertValuesObjectToArray(restOfValues),
        defaultValue: restOfDefault
      };
      return acc;
    },
    {}
  );
};
